var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"headerImg",class:_vm.className},[_c('div',{staticClass:"headerImgBack"},[_c('div',[_c('h2',{staticClass:"headerImgTitle"},[_vm._t("Title")],2),_vm._v(" "),_c('p',{staticClass:"headerImgText"},[_vm._t("Text")],2)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6aa9f5a6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/headerImg.vue
// module id = null
// module chunks = 